import type { TFunction, TOptions } from "i18next";

export function resolveChartTitle({
  t,
  translationKey,
  featureEnabled,
  i18nParams = {},
  defaultText,
  name,
}: {
  t: TFunction;
  translationKey?: string;
  featureEnabled: boolean;
  i18nParams?: TOptions;
  defaultText?: string;
  name?: string;
}): string {
  const base = (defaultText?.trim()) || (name?.trim()) || "";

  if (featureEnabled && translationKey?.trim()) {
    const res = t(translationKey, { defaultValue: base, ...i18nParams });
    if (typeof res === "string") {
      const translated = res.trim();
      if (translated && translated !== translationKey) {
        return translated;
      }
    }
  }

  return base;
}
